<div class="flex items-center gap-3">
  @if (showSuccess) {
    <span class="text-muted-foreground flex items-center gap-1.5 text-sm">
      <ng-icon name="lucideCircleCheck" class="text-foreground" />
      {{ successMessage }}
    </span>
  }

  @if (showError && errorMessage) {
    <span class="text-destructive flex items-center gap-1.5 text-sm">
      <ng-icon name="lucideTriangleAlert" />
      {{ errorMessage }}
    </span>
  }

  <button
    hlmBtn
    [type]="type"
    [size]="hlmSize"
    [class.w-full]="width === 'full'"
    [disabled]="disabled || loading"
    (click)="onClick()">
    @if (loading) {
      <hlm-spinner />
      {{ loadingText }}
    } @else {
      {{ text }}
    }
  </button>
</div>
